// FAQページ用JavaScript（店舗ページと同じ構造）
document.addEventListener('DOMContentLoaded', function() {
  smoothScroll();
  openLinkedFaq();
});

function getFaqScrollOffset() {
  const headerElement = document.querySelector('header') || document.querySelector('.header');
  const headerHeight = headerElement ? headerElement.offsetHeight : 64;
  const desiredPadding = window.innerWidth >= 768 ? 160 : 80;

  return headerHeight + desiredPadding;
}

function scrollToFaqTarget(target, behavior = 'smooth') {
  const targetPosition = target.getBoundingClientRect().top + window.scrollY;

  window.scrollTo({
    top: targetPosition - getFaqScrollOffset(),
    behavior
  });
}

function openLinkedFaq() {
  const hash = window.location.hash;

  if (!hash) {
    return;
  }

  let targetId;

  try {
    targetId = decodeURIComponent(hash.slice(1));
  } catch (error) {
    return;
  }

  const target = document.getElementById(targetId);

  if (!target || !target.classList.contains('js-trigger')) {
    return;
  }

  target.classList.add('is-open');

  // アコーディオン初期化とレイアウト確定後に表示位置を補正する
  setTimeout(() => scrollToFaqTarget(target, 'auto'), 100);
}

function smoothScroll() {
  const targets = document.querySelectorAll('.anker-list a[href^="#"]');
  
  if (targets.length === 0) {
    return;
  }

  targets.forEach(target => {
    target.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      
      const href = target.getAttribute('href');
      // href属性を一時的に削除してブラウザのデフォルト動作を完全に防ぐ
      target.removeAttribute('href');
      
      const scrollTarget = document.querySelector(href === '#' || href === '' ? 'html' : href);
      
      if (scrollTarget) {
        // 実際の見出し要素を取得
        const headingElement = scrollTarget.querySelector('.faq-content__ttl');

        scrollToFaqTarget(headingElement || scrollTarget);
        
        // href属性を復元（スクロール完了後）
        setTimeout(() => {
          target.setAttribute('href', href);
        }, 500);
      }
    });
  });
}
